import React from 'react';
import { BaseComponent } from '../../components/BaseComponent';
import { withMsal } from "@azure/msal-react";
import { Loader } from "../../components/Loader";
import config from '../../env';

/* eslint-disable react/prefer-stateless-function */
class MsalLoaderComp extends BaseComponent {
  componentDidMount() {
  }

  render() {
    if (
      config?.auth_flow === 'AZURE' &&
      (!this.props.msalContext?.inProgress || this.props.msalContext?.inProgress !== 'none')
    ) return <Loader onCard/>;

    return (<>{this.props.children}</>);
  }
}

export const MsalLoader = withMsal(MsalLoaderComp);

